export const TILE_EDGES_COUNT = 4;
export const TILE_EDGE_TOP = 0;
export const TILE_EDGE_BOTTOM = 1;
export const TILE_EDGE_LEFT = 2;
export const TILE_EDGE_RIGHT = 3;
export const TILE_EDGE_HASH = 0;
export const BITS_MASK_CHUNK = 32;
export const BITS_MASK_CHUNK_LOG2 = 5;
export const TILE_EDGES_NAMES = [
  "TOP",
  "🔻 BOTTOM 🔻",
  "LEFT",
  "RIGHT",
  "FRONT",
  "BACK",
];
